import { useState } from 'react';
import { Button, Grid, MenuItem, Popover } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Form } from 'react-final-form';
import { map } from 'lodash';

import SelectField from 'common/forms/SelectField';
import DateField from 'common/forms/DateField';
import TextField from 'common/forms/TextField';
import { filterInClaimElgibilityRequests } from 'store/thunks/workQueueThunks';
import RequestStatus from 'enums/request.enum';
import { validateMinLength } from 'common/forms/formValidations';
import lineItemStatus from 'common/constants/lineItemStatus';

const InClaimEligibilityFilterButton = () => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);
  const filter = useSelector(({ workQueue: { inClaimEligibility } }) => ({
    ...inClaimEligibility.filter,
    requestedDate:
      inClaimEligibility.filter?.requestedDate && new Date(inClaimEligibility.filter.requestedDate),
    shipByDate:
      inClaimEligibility.filter?.shipByDate && new Date(inClaimEligibility.filter.shipByDate),
  }));

  const partners = useSelector(({ auth, partner }) => partner[auth.currentTenantId]);

  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  const popoverId = anchorEl ? 'WorkQueue-InClaimEligibilityFilterButton-Popover' : undefined;

  const handleApplyFilter = (formData) => {
    setAnchorEl(null);

    dispatch(
      filterInClaimElgibilityRequests({
        filter: {
          ...formData,
          requestedDate: formData.requestedDate && formData.requestedDate.toISOString(),
          shipByDate: formData.shipByDate && formData.shipByDate.toISOString(),
          requestStatus: RequestStatus.OPEN,
        },
      })
    );
  };

  return (
    <>
      <Button
        sx={{ height: 33 }}
        variant='outlined'
        color='secondary'
        onClick={handleOpen}
        aria-describedby={popoverId}
      >
        Filters
      </Button>

      <Popover
        id={popoverId}
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Grid container sx={{ p: 1.5, width: 325 }} spacing={2} direction='column'>
          <Grid item>
            <Form
              initialValues={filter}
              onSubmit={handleApplyFilter}
              render={({ handleSubmit, invalid }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <Grid item sx={{ py: 0.5 }}>
                    <TextField
                      label='Patient Name'
                      name='patientName'
                      id='WorkQueue-InClaimEligibilityFilterButton-patientName-input'
                      validations={[validateMinLength('Minimum of 3 characters', 3)]}
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <SelectField
                      label='Partner Name'
                      name='partnerUuid'
                      id='WorkQueue-InClaimEligibilityFilterButton-partnerUuid-dropdown'
                    >
                      <MenuItem value=''>All</MenuItem>
                      {map(partners, ({ partnerName, partnerUuid }) => (
                        <MenuItem value={partnerUuid} key={partnerUuid}>
                          {partnerName}
                        </MenuItem>
                      ))}
                    </SelectField>
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <DateField
                      label='Requested Date'
                      name='requestedDate'
                      id='WorkQueue-InClaimEligibilityFilterButton-requestedDate-dateField'
                      maxDate={new Date()}
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <DateField
                      label='Ship By Date'
                      name='shipByDate'
                      id='WorkQueue-InClaimEligibilityFilterButton-shipByDate-dateField'
                    />
                  </Grid>
                  <Grid item sx={{ py: 0.5 }}>
                    <SelectField
                      label='Status'
                      name='state'
                      id='WorkQueue-InClaimEligibilityFilterButton-status-dropdown'
                    >
                      <MenuItem value=''>All</MenuItem>
                      {map(lineItemStatus, (value, key) => (
                        <MenuItem value={key} key={key}>
                          {value}
                        </MenuItem>
                      ))}
                    </SelectField>
                  </Grid>

                  <Grid container justifyContent='flex-end'>
                    <Button variant='contained' type='submit' disabled={invalid}>
                      Apply
                    </Button>
                  </Grid>
                </form>
              )}
            />
          </Grid>
        </Grid>
      </Popover>
    </>
  );
};

export default InClaimEligibilityFilterButton;
